import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref, onMounted, onUnmounted, watch} from 'vue'



export default /*@__PURE__*/_defineComponent({
  __name: 'CountDownTxtCss',
  props: {
    endTime: {}
  },
  setup(__props: any) {

const props = __props

const h = ref('00')
const m = ref('00')
const s = ref('00')
const msDelay = ref('0s')
const isExpired = ref(false)

let timer: number | null = null

const update = () => {
  const now = Date.now()
  const remain = props.endTime - now

  if (remain <= 0) {
    h.value = m.value = s.value = '00'
    isExpired.value = true
    if (timer) clearInterval(timer)
    return
  }

  // 计算时分秒
  h.value = Math.floor(remain / 3600000).toString().padStart(2, '0')
  m.value = Math.floor((remain % 3600000) / 60000).toString().padStart(2, '0')
  s.value = Math.floor((remain % 60000) / 1000).toString().padStart(2, '0')

  // 同步 CSS 毫秒动画：
  // 利用负延迟让 0-9 的 CSS 滚动动画直接跳到当前的毫秒进度
  const currentMs = remain % 1000
  msDelay.value = `-${1000 - currentMs}ms`
}

onMounted(() => {
  update()
  timer = window.setInterval(update, 1000)
})

onUnmounted(() => {
  if (timer) clearInterval(timer)
})

watch(() => props.endTime, () => {
  isExpired.value = false
  update()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["countdown", { 'expired': isExpired.value }])
  }, [
    _createTextVNode(_toDisplayString(h.value) + ":" + _toDisplayString(m.value) + ":" + _toDisplayString(s.value) + ". ", 1),
    _createElementVNode("div", {
      class: "ms-node",
      style: _normalizeStyle({ '--ms-delay': msDelay.value })
    }, null, 4)
  ], 2))
}
}

})